<template>
  <div class="grid">
    <div class="col-12">
      <div class="card">
        <Toast />
        <Toolbar class="mb-4">
          <template v-slot:start>
            <div class="my-2">
              <Button
                label="Nuevo"
                icon="pi pi-plus"
                class="p-button-success mr-2"
                @click="openNew"
              />
               
            </div>
          </template>

          <template v-slot:end>
            <Button
              label="Exportar"
              icon="pi pi-upload"
              class="p-button-help"
              @click="exportCSV($event)"
            />
          </template>
        </Toolbar>

        <DataTable
          ref="dt"
          :value="data"
          v-model:selection="selectedData"
          dataKey="id"
          :paginator="true"
          :rows="10"
          :filters="filters"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} Sectores"
          responsiveLayout="scroll"
        >
          <template #header>
            <div
              class="
                flex flex-column
                md:flex-row md:justify-content-between md:align-items-center
              "
            >
              <h5 class="m-0">Sectores</h5>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>


          <Column
            field="name"
            header="Nombre"
            :sortable="true"
            headerStyle="width:40%; min-width:10rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Nombre</span>
              {{ slotProps.data.name }}
            </template>
        </Column>

        <Column
            field="description"
            header="Descripción"
            :sortable="true"
            headerStyle="width:40%; min-width:10rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Descripción</span>
              {{ slotProps.data.description }}
            </template>
        </Column>

        <Column
            field="user_id"
            header="Supervisor"
            :sortable="true"
            headerStyle="width:40%; min-width:10rem;"
          >
            <template #body="slotProps">
              <span class="p-column-title">Supervisor</span>
              {{ giveMeName(slotProps.data?.user_id) }}
            </template>
        </Column>

          <Column headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="editItem(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mt-2"
                @click="confirmDeleteItem(slotProps.data)"
              />
            </template>
          </Column>
        </DataTable>

        <Dialog
          v-model:visible="itemDialog"
          :style="{ width: '500px' }"
          header="Sectores"
          :modal="true"
          class="p-fluid"
        >
          <div class="field">
            <label for="name">Nombre </label>
            <InputText
              id="name"
              v-model.trim="item.name"
              required="true"
              autofocus
              :class="{ 'p-invalid': submitted && !item.name }"
            />
            <small class="p-invalid" v-if="submitted && !item.name"
              >Nombre es requerido.</small
            >
          </div>

          <div class="field">
            <label for="name">Descripción </label>
            <InputText
              id="description"
              v-model.trim="item.description"
              autofocus
              :class="{ 'p-invalid': submitted && !item.description }"
            />            
          </div>

          <div class="field">
            <label for="user">Supervisor </label>
            <AutoComplete
                    v-model="item.user"
                    :suggestions="filteredUser"
                    @complete="searchUser($event)"
                    field="name"
                    :dropdown="true"
                    @item-select="item.user_id = item.user.id;;"
                    id="user_id"
                    class="inputfield w-full"
                  />
          </div>

          <div class="card">
            <div class="">
              <div class="formgrid grid">
                <div class="field col-8">
                  <label for="base">Operarios</label>
                  <AutoComplete
                    v-model="selectedUser"
                    :suggestions="filteredUser"
                    @complete="searchUser($event)"
                    field="name"
                    :dropdown="true"
                    @item-select="newItemUser = selectedUser"
                    id="base"
                    class="inputfield w-full"
                  />
                </div>

              <div class="field col-4">        
                <Button :disabled="!newItemUser"  @click="addItemUser(newItemUser)" label="Agregar" 
                  icon="pi pi-plus" class="p-button-success inputfield w-full mt-5" />
              </div>
            </div>

            <DataTable
              :value="operarios"
              dataKey="id" 
              class="p-datatable-sm"
              responsiveLayout="scroll"
            >
              <Column field="id" header="" >
                <template #body="slotProps">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delItemUser(slotProps.data.id)"></Button>
                </template>
              </Column>
              <Column field="name" header="Operario">
              <template #body="slotProps">
                <b>
                  {{ slotProps.data.name }}
                </b>
                </template>
              </Column>            
            </DataTable>
          </div>
        </div>

        <div class="card">
            <div class="">
              <div class="formgrid grid">
                <div class="field col-8">
                  <label for="base">Materiales</label>
                  <AutoComplete
                    v-model="selectedMaterial"
                    :suggestions="filteredMaterial"
                    @complete="searchMaterial($event)"
                    field="name"
                    :dropdown="true"
                    @item-select="newItemMaterial = selectedMaterial"
                    id="base"
                    class="inputfield w-full"
                  />
                </div>

              <div class="field col-4">        
                <Button :disabled="!newItemMaterial"  @click="addItemMaterial(newItemMaterial)" label="Agregar" 
                  icon="pi pi-plus" class="p-button-success inputfield w-full mt-5" />
              </div>
            </div>

            <DataTable
              :value="materiales"
              dataKey="id" 
              class="p-datatable-sm"
              responsiveLayout="scroll"
            >
              <Column field="id" header="" >
                <template #body="slotProps">
                    <Button icon="pi pi-times" class="p-button-rounded p-button-danger" @click="delItemMaterial(slotProps.data.id)"></Button>
                </template>
              </Column>
              <Column field="name" header="Material">
              <template #body="slotProps">
                <b>
                  {{ slotProps.data.name }}
                </b>
                </template>
              </Column>            
            </DataTable>
          </div>
        </div>
          

          <template #footer>
            <Button
              label="Cancelar"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              label="Guardar"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveItem"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteItemDialog"
          :style="{ width: '450px' }"
          header="Confirmación"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item"
              >Eliminaras a <b>{{ item.name }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteItemDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteItem"
            />
          </template>
        </Dialog>

        <Dialog
          v-model:visible="deleteDataDialog"
          :style="{ width: '450px' }"
          header="Confirm"
          :modal="true"
        >
          <div class="flex align-items-center justify-content-center">
            <i
              class="pi pi-exclamation-triangle mr-3"
              style="font-size: 2rem"
            />
            <span v-if="item">Seguro?</span>
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteDataDialog = false"
            />
            <Button
              label="Sí"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteSelectedData"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import CrudService from "../services/crud.service";

export default {
  data() {
    return {
      routeName: null,
      data: [{id:null, name:'', description:'', user_id: null, user_name:''}],
      itemDialog: false,
      deleteItemDialog: false,
      deleteDataDialog: false,
      item: {id:null, name:'', description:'', user_id: null, user_name:'', operarios: null},
      selectedData: null,
      filters: {},
      submitted: false,
      validationErrors: null,
      operarios: [],
      materiales: [],
      materials: [],
      users: [],
      newItemUser: null,
      newItemMaterial: null,
      filteredUser: null,
      filteredMaterial: null,
      selectedUser : null,
      selectedMaterial : null
    };
  },
   
  created() {
    this.routeName = this.$route.name;
     
    this.initFilters();
  },
  mounted() {
    CrudService.getCRUD('operarios').then((data) => (this.users = data));
    CrudService.getCRUD('material').then((data) => (this.materials = data));
     CrudService.getCRUD(this.routeName).then(
      (data) => {
        this.data = data;
        console.log('this.data')
        console.log(this.data)
        if (data.operarios) {
          data.operarios.forEach((item) => {
            let name = item?.operario.name;
            let id = item?.operario.id;
            let obj = {
              id: id,
              name: name
            };
            this.operarios.push(obj);
          });
        }
        if (data.materiales) {
          data.materiales.forEach((item) => {
            let name = item?.material.name;
            let id = item?.material.id;
            let obj = {
              id: id,
              name: name
            };
            this.materiales.push(obj);
          });
        }
      }
    );    

  },
  methods: {   
    giveMeName (user_id) {
      let users = this.users.filter((item) => item.id == user_id);
      if (users.length) {
        let last_name = users[0].last_name || '';
        return users[0].name + ' ' + last_name;
      }
      return '';
    },
    delItemUser(itemId){
      console.log(itemId)
      let index = this.operarios.findIndex(item => item.id == itemId);
      this.operarios.splice(index, 1);
    }, 
    delItemMaterial(itemId){
      console.log(itemId)
      let index = this.materiales.findIndex(item => item.id == itemId);
      this.materiales.splice(index, 1);
    }, 
    searchUser(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredUser = [...this.users];
        } else {
          this.filteredUser = this.users.filter((user) => {
            return user.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    searchMaterial(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.filteredMaterial = [...this.materials];
        } else {
          this.filteredMaterial = this.materials.filter((item) => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }, 250);
    },
    addItemUser() {
      if (this.newItemUser) {
        console.log(this.newItemUser);
        this.operarios.push({
          id: this.newItemUser.id,
          name: this.newItemUser.name          
        });
        this.actualFormulaUser = null;
        this.newItemUser = null;
        this.selectedUser = null;
      }
    },
    addItemMaterial() {
      if (this.newItemMaterial) {
        console.log(this.newItemMaterial);
        this.materiales.push({
          id: this.newItemMaterial.id,
          name: this.newItemMaterial.name          
        });
        this.newItemMaterial = null;
        this.selectedMaterial = null;
      }
    },
    openNew() {
      this.item = {};
      this.operarios = [];
      this.materiales = [];
      
      this.submitted = false;
      this.itemDialog = true;
    },
    hideDialog() {
      this.itemDialog = false;
      this.submitted = false;
    },
    displayErrors(errors) {      
              for (let key in errors) {
                this.validationErrors.push({ "field": key, "message": errors[key] });
                let error = errors[key];
                this.$toast.add({
                  severity: "error",
                  summary: "Error!",
                  detail: error[0],
                  life: 3000,
                });
              }
    },
    saveItem() {
      this.submitted = true;
      if (this.item.name) {
        if (this.item.id) {  

          this.item.operarios = this.operarios;
          this.item.materiales = this.materiales;
          CrudService.updateCRUD(this.routeName, this.routeName, this.item).then(
            (response) => {

            this.validationErrors = [];
            if (response.status == 400) { 

              this.displayErrors(response.data);

            } else {
              this.$toast.add({
                severity: "success",
                summary: "Éxito!",
                detail: "Actualizado correctamente.",
                life: 3000,
              });
              this.data[this.findIndexById(this.item.id)] = this.item;
              this.data[this.findIndexById(this.item.id)].operarios = [];
              this.data[this.findIndexById(this.item.id)].materiales = [];
              
              response.data.operarios.forEach((item) => {
                this.data[this.findIndexById(this.item.id)].operarios.push(item);                
              });
              response.data.materiales.forEach((item) => {
                this.data[this.findIndexById(this.item.id)].materiales.push(item);                
              });
              
              this.itemDialog = false;
              this.item = {};
              this.operarios = [];
              this.materiales = [];
            }
          });
        } else {
          this.item.operarios = this.operarios;
          this.item.materiales = this.materiales;
          CrudService.createCRUD(this.routeName, this.routeName, this.item).then(
            (response) => {
              
            this.validationErrors = [];
            if (response.status == 400) { 

              this.displayErrors(response.data);
              
              } else {
                this.data.push(response.data);
                this.$toast.add({
                  severity: "success",
                  summary: "Éxito!",
                  detail: "Creado correctamente.",
                  life: 3000,
                });
                this.itemDialog = false;
                this.item = {};
                this.operarios = [];
                this.materiales = [];
              }
            }
          );
        }
      }
    },
    editItem(item) {
      this.operarios = [];
      this.materiales = [];
      this.item = { ...item };
      this.item.operarios.forEach((item) => {
        let name = item?.operario.name;
        let id = item?.operario.id;        
        let obj = {
          id: id,
          name: name
        };
        this.operarios.push(obj);
      });
      this.item.materiales.forEach((item) => {
        let name = item?.material.name;
        let id = item?.material.id;        
        let obj = {
          id: id,
          name: name
        };
        this.materiales.push(obj);
      });
      this.itemDialog = true;
    },
    confirmDeleteItem(item) {
      this.item = item;
      this.deleteItemDialog = true;
    },
    deleteItem() {
      CrudService.deleteCRUD(this.routeName, this.routeName, this.item.id).then(
        (response) => {
          //this.data.splice(this.findIndexById(data.data.id), 1);
          this.data = this.data.filter((item) => item.id != response.data);
          this.item = {};
          this.$toast.add({
            severity: "success",
            summary: "Éxito!",
            detail: "Eliminado correctamente.",
            life: 3000,
          });
        }
      );

      this.deleteItemDialog = false;
      this.item = {};
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].id == id) {
          index = i;
          break;
        }
      }
      return index;
    },
    createId() {
      let id = "";
      var chars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (var i = 0; i < 5; i++) {
        id += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      return id;
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteDataDialog = true;
    },
    deleteSelectedData() {
      this.data = this.data.filter(
        (val) => !this.selectedData.includes(val)
      );
      this.deleteDataDialog = false;
      this.selectedData = null;
      this.$toast.add({
        severity: "success",
        summary: "Éxito!",
        detail: "Eliminado correctamente.",
        life: 3000,
      });
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
